/**
 * Conductor Invoices to Sage Bill – Manual Run handler.
 * POSTs { sflId, tenantId } only. Backend pulls invoices from Conductor GET API.
 */

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}synctrack/conductor/invoice-to-sage-bill`;

export const handleConductorInvoiceToSageBillFlow = async (syncFlow) => {
  const token = localStorage.getItem('token');
  const tenantId = localStorage.getItem('tenantId');
  const sflId = syncFlow.instanceId || syncFlow.sfiId;

  if (!sflId) {
    throw new Error('Flow instance ID (sflId) is missing');
  }
  if (!tenantId) {
    throw new Error('tenantId is missing. Ensure you are logged in.');
  }

  const body = {
    sflId,
    tenantId: Number(tenantId),
  };

  const response = await fetch(API_BASE, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || `API error: ${response.status}`);
  }

  if (data.success === false) {
    throw new Error(data.message || 'Conductor Invoices to Sage Bill run failed');
  }

  return data;
};
